import React from 'react'
import styled from 'styled-components'
import { ContactForm } from '../components/ContactForm'
import { Container } from '../styles/common.styles'
import { Text } from '../components/Text'

const ContactContainer = styled.div`
  min-height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4rem 0;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.8) 0%,
    rgba(0, 0, 0, 0.9) 100%
  );
`

const ContactHeader = styled.div`
  text-align: center;
  margin-bottom: 3rem;
`

const ContactTitle = styled.h1`
  font-size: 2.5rem;
  color: #ffffff;
  margin-bottom: 1rem;
  background: linear-gradient(45deg, #4ecdc4, #ff6b6b);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`

export function ContactPage() {
  return (
    <ContactContainer>
      <Container>
        <ContactHeader>
          <ContactTitle>Get in Touch</ContactTitle>
          <Text
            text="Have a question or want to work together? Feel free to reach out using the form below. I'll get back to you as soon as possible."
            color='rgba(255, 255, 255, 0.8)'
            maxWidth='600px'
            margin='0 auto'
          />
        </ContactHeader>
        <ContactForm />
      </Container>
    </ContactContainer>
  )
}
